export default __webpack_public_path__ + "static/bodySectionBg-d231bced24010a6f01316ba1146968d1.png";